import { DeliveryPickup } from '~/contracts/common';

enum DaysRange {
  SameDayDelivery,
  UnderFourDays,
  Tomorrow,
  OverFourDays,
  Unknown
}

function getDaysRange(daysUntilDeliveryOrPickup: number) {
  if (daysUntilDeliveryOrPickup < 1) return DaysRange.SameDayDelivery;
  if (daysUntilDeliveryOrPickup === 1) return DaysRange.Tomorrow;
  if (daysUntilDeliveryOrPickup > 1 && daysUntilDeliveryOrPickup <= 4)
    return DaysRange.UnderFourDays;
  if (daysUntilDeliveryOrPickup > 4) return DaysRange.OverFourDays;

  return DaysRange.Unknown;
}

const getTagGetItBy = (route?: DeliveryPickup) => {
  if (!route) return null;

  const { daysToAvailability, asSoonAsText } = route;
  const tagTextMap = {
    [DaysRange.SameDayDelivery]: 'Get it Today',
    [DaysRange.UnderFourDays]: `Get it ${asSoonAsText}`,
    [DaysRange.Tomorrow]: 'Get it Tomorrow',
    [DaysRange.OverFourDays]: null,
    [DaysRange.Unknown]: null
  };

  return tagTextMap[getDaysRange(daysToAvailability)];
};

export default getTagGetItBy;
